import React, { useState } from "react";
import { transactionStatus } from "pages/transactions/constants";
import * as i18n from "util/i18n";
import Button from "pages/_components/Button";
import { ResponsiveHeader } from "pages/_components/header";
import MainContainer from "pages/_components/MainContainer";
import useReactPrint from "pages/_components/Print/useReactToPrint";
import { TransactionCard, TransactionHeader } from "pages/_components/TransactionCard";
import { Col, Row } from "react-bootstrap";
import { actions as debinActions } from "reducers/debin";
import { useTransaction } from "hooks/useTransactions";
import { bool } from "prop-types";
import Notification from "pages/_components/Notification";
import gaEventTracker, { events } from "util/gaEventTracker";
import SolicitDebinBody from "./SolicitDebinBody";

const SolicitDebinSuccess = ({ isDesktop }) => {
    const formatTransaction = (data, idTransaction) => ({ ...data, idTransaction });

    const {
        isLoading,
        transaction,
        dispatch,
        handleSignTransaction,
        showSignButton,
        push,
        id,
        status,
    } = useTransaction(
        "/debinPayments/solicitDebin/confimation",
        debinActions.setSolicitDebin,
        debinActions.cleanDebinTicket,
        formatTransaction,
    );
    const { componentRef, handlePrint, mobileRef, handleShareMobile } = useReactPrint(
        "Solicitar DEBIN",
        id,
        "debinTrasaction",
    );
    const isFinished = transactionStatus.FINISHED === transaction.idTransactionStatus;
    const backLinkTo = status?.isFlowComplete ? "/debinPayments" : "";
    const [showMoreData, setShowMoreData] = useState(!isDesktop);

    const handleDownload = async () => {
        await setShowMoreData(true);
        gaEventTracker.triggerEvent(events.debin_solicitar_descargar());
        return handlePrint();
    };

    return (
        <>
            <Notification scopeToShow="debinTrasaction" />
            {!status?.isBackoffice && <ResponsiveHeader ticket metaTitle="debin.solicit" backLinkTo={backLinkTo} />}
            <MainContainer showLoader={isLoading}>
                <div className="container" ref={componentRef}>
                    <div ref={mobileRef}>
                        <TransactionCard transaction={transaction}>
                            <TransactionHeader title="debin.solicit" />
                            <div className="ticket">
                                <div className="ticket__wrapper">
                                    <div className="ticket__header" />
                                    <SolicitDebinBody
                                        solicitDebin={transaction?.data}
                                        recipients={[]}
                                        showConfirmation
                                        status={status}
                                        expirationDate={transaction?.data?.expirationDate}
                                        isDesktop={isDesktop}
                                        setShowMoreData={setShowMoreData}
                                        showMoreData={showMoreData}
                                    />
                                    <div className="ticket__footer" data-copytext={i18n.get("global.ticketCopyText")} />
                                </div>
                            </div>
                        </TransactionCard>
                    </div>
                    {!status?.isBackoffice && (
                        <Row className="form-actions no-print">
                            <Col xs={12} md={4} mdOffset={showSignButton || isFinished ? 2 : 4}>
                                <Button
                                    onClick={() => dispatch(push("/desktop"))}
                                    label="forms.transaction.ticket.actions.backToHome"
                                    className={`btn${showSignButton || isFinished ? " btn-outline" : " btn-primary"}`}
                                />
                            </Col>
                            {isFinished && (
                                <>
                                    <Col xs={12} md={4}>
                                        <Button
                                            onClick={handleDownload}
                                            label="global.download"
                                            className="btn btn-primary"
                                            image="images/download.svg"
                                        />
                                    </Col>
                                    {!isDesktop && (
                                        <Col xs={12} md={4}>
                                            <Button
                                                className="btn btn-outline"
                                                image="images/figma/icon/share.svg"
                                                label="global.share"
                                                onClick={() => {
                                                    handleShareMobile();
                                                }}
                                            />
                                        </Col>
                                    )}
                                </>
                            )}
                            {showSignButton && (
                                <Col xs={12} md={4}>
                                    <Button
                                        onClick={handleSignTransaction}
                                        label="forms.signTransaction.link"
                                        className="btn btn-primary"
                                    />
                                </Col>
                            )}
                        </Row>
                    )}
                </div>
            </MainContainer>
        </>
    );
};

SolicitDebinSuccess.propTypes = {
    isDesktop: bool.isRequired,
};

export default SolicitDebinSuccess;
